/**
 * Temporary customer feature flags.
 * Flip these back to true when the feature should be visible again.
 * Admin / backend membership APIs stay enabled regardless.
 */
export const CUSTOMER_MEMBERSHIP_ENABLED = false;
